export default __webpack_public_path__ + "static/media/pic14.076c95e5.jpg";